import React from 'react';
import style from "./style.scss";

const iconSrc = {
    'elearning': '/assets/images/icons/1947_RIAMS_icon_e-learning_white.png',
    'conference': '/assets/images/icons/1947_RIAMS_icon_conference_white.png',
    'course': '/assets/images/icons/1947_RIAMS_icon_courses_white.png',
    'webinar': '/assets/images/icons/icon_training_webinar.png'
};

export default ({className, type = 'course', backgroundColour = '#2d5ab4'}) => {
    return (
        <div className={`${style['icon-container']} ${className}`} style={{backgroundColor: backgroundColour}}>
            <img alt={type} className={style['icon']} src={iconSrc[type]} />
        </div>
    )
};


// WEBPACK FOOTER //
// ./components/TrainingTypeIcon/index.js